import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as support from '../../actions/support';
import { Observable, Subscription } from 'rxjs';
import { SocialMediaLinks, SocialIcon } from '../../interfaces';

@Component({
  selector: 'edge-soccer',
  templateUrl: './soccer.component.html',
  styleUrls: ['./soccer.component.scss']
})
export class PageSoccerComponent implements OnInit {
  tagline = '<span>GoArmy Edge.</span> Create. Visualize. Learn. Compete.';
  socialIcons = [
    {
      link: 'https://twitter.com/goarmyedge',
      image: '/assets/images/social/logo-white.png',
      alt: 'Twitter',
      sport: 'Soccer'
    },
    {
      link: 'https://www.youtube.com/goarmyedge',
      image: '/assets/images/social/youtube.svg',
      alt: 'YouTube',
      sport: 'Soccer'
    },
    {
      link: 'https://www.facebook.com/GoArmyEdgeSoccer/',
      image: '/assets/images/social/facebook.svg',
      alt: 'Facebook',
      sport: 'Soccer'
    }
  ];
  testimonial = `
    "GoArmy Edge Soccer can help with learning the four phases of the game:
    defending, attacking, offense-defense transition, and defense-offense
    transition. Also offensive and defensive set pieces including corner kicks,
    and free kicks. It can help teams learn to 'spread' the field and create
    space on offense and "compact" the field and reduce lanes on defense."`;
  author = 'Derek Mann, Jacksonville University';
  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    this.store.dispatch(support.ToggleSupportPageAction('soccer'));

    this.store.dispatch(support.ToggleSupportPageAction('soccer'));
  }
}
